import { ReactNode } from 'react'

/** Right-aligned toolbar row for primary actions (add / export, etc.). */
const PrimaryPageActions = ({ children, className = '' }: { children: ReactNode; className?: string }) => {
	return <div className={`flex flex-wrap items-center justify-end gap-2 ${className}`.trim()}>{children}</div>
}

export default PrimaryPageActions
